import React from 'react';
import withTranslation from '../../../hoc/withTranslation';
import PropTypes from 'prop-types';
import { Paper, Subheader } from 'material-ui';
import style from '../../../styles/styles';
import Info from '../../common/Info/Info';

class QuizInfo extends React.Component {
    static propTypes = {
        quiz: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        lang: PropTypes.string,
    };

    static defaultProps = {
        lang: 'fr',
    };

    render() {
        const quiz = this.props.quiz;
        return (
            <Paper>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('generic.information')}
                </Subheader>
                <div style={style.paper}>
                    <Info
                        title={this.props.t('generic.identifier')}
                        content={quiz.id}
                    />
                    {quiz.name &&
                        <Info
                            title={this.props.t('generic.name')}
                            content={quiz.name}
                        />
                    }
                    <Info
                        title={this.props.t('module.quiz.user_quiz_response_count')}
                        content={quiz.user_quiz_response_count}
                    />
                    <Info
                        title={this.props.t('module.quiz.good_user_quiz_response_count')}
                        content={quiz.good_user_quiz_response_count}
                    />
                    {quiz.latitude && <Info
                        title="Latitude"
                        content={quiz.latitude}
                    />
                    }
                    {quiz.longitude && <Info
                        title="Longitude"
                        content={quiz.longitude}
                    />}
                </div>
            </Paper>
        );
    }
}

export default withTranslation(QuizInfo);



// WEBPACK FOOTER //
// src/components/quiz/QuizInfo/QuizInfo.js